




































import { Component, Vue } from 'vue-property-decorator'

@Component({ components: {} })
export default class extends Vue {
  get items() {
    return [{ link: '/', text: 'Home' }, { link: '/timeline', text: 'Timeline' }, { link: '/about', text: 'About' }]
  }
}
